import React from 'react';
import {
  Edit,
  SimpleForm,
  DateField,
  Filter,
  TextInput,
  List,
  Datagrid,
  ReferenceField,
  RichTextField,
  TextField,
  ShowButton,
  FunctionField,
  Toolbar,
  SaveButton,
  CardActions,
  ListButton,
} from 'react-admin';
import Button from '@material-ui/core/Button';
import { DateInput } from 'react-admin-date-inputs';
import PolarityField from './ui/PolarityField';

const TweetToolbar = props => (
  <Toolbar {...props} >
      <SaveButton />
  </Toolbar>
);

export const TweetsList = props => (
  <List title="Tweets"
        bulkActionButtons={false}
        {...props}
        sort={{ field: 'publish_date', order: 'desc' }}
        perPage={25}
        filters={<DateFilter />}>
    <Datagrid>
      <ReferenceField label="User" source="user_id" addLabel reference="twitterusers">
        <TextField source="name" />
      </ReferenceField>
      <FunctionField
        sortable={false}
        source="url"
        label="Tweet"
        render={(record, source) => (
          <a href={record[source]} target="_blank" rel="noopener noreferrer">
            {record['text']}
          </a>
        )}
      />
      <TextField label="Activities" source="activities.total" />
      <TextField source="source_type" />
      <PolarityField source="tag" />
      <DateField source="publish_date" showTime={true} />
      <ShowButton label="" />
    </Datagrid>
  </List>
);

const DateFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <DateInput label="Published After" source="range.publish_date.gte" options={{ format: 'dd.MM.yyyy', clearable: true }} />
    <DateInput label="Published Before" source="range.publish_date.lte" options={{ format: 'dd.MM.yyyy', clearable: true }} />
  </Filter>
);

const TweetEditActions = ({ basePath, data, resource }) => (
  <CardActions>
      {data && 
        <Button style={{marginRight: '10px'}} variant="outlined" color="primary" href={data.url} target="_blank" rel="noopener noreferrer">
          Link
        </Button>}
      <ListButton basePath={basePath} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
  </CardActions>
);

export const TweetEdit = props => (
  <Edit title="Tweet" actions={<TweetEditActions />} {...props}>
    <SimpleForm toolbar={<TweetToolbar />}>
      <RichTextField source="text" />
      <ReferenceField label="User" source="user_id" addLabel reference="twitterusers">
        <TextField source="name" />
      </ReferenceField>
      <DateField source="publish_date" />
      <TextField label="Activities" source="activities.total" />
      <TextField label="Favorites" source="activities.favorites" />
      <TextField label="Retweets" source="activities.retweets" />
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/resources/tweets.js